import React from 'react';

export default function Clipboard({ fillColor = '#8B90A0' }) {
  return (
    <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.21294 3.23169L2.60459 3.23177L1 3.23197V15H11.9564V3.23197L9.74284 3.23169" stroke={fillColor} strokeWidth="0.75" />
      <rect x="3.98828" y="1" width="4.9802" height="2.7053" rx="1" stroke={fillColor} strokeWidth="0.75" />
      <path d="M10.0762 7.08699H2.88254" stroke={fillColor} strokeWidth="0.75" strokeLinecap="round" />
      <path d="M10.0762 9.52205H2.88254" stroke={fillColor} strokeWidth="0.75" strokeLinecap="round" />
      <path d="M6.47754 11.9571H3.1574" stroke={fillColor} strokeWidth="0.75" strokeLinecap="round" />
    </svg>
  )
}